import React from 'react';
import { motion } from 'framer-motion';
export function RevelationSection() {
  return <section className="py-24 px-4 relative overflow-hidden" data-id="element-189">
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-[#8B5CF6]/10 rounded-full blur-[120px] -z-10" data-id="element-190"></div>

      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="flex-1 space-y-8" data-id="element-192">
          <div className="text-gray-400 text-lg space-y-2" data-id="element-193">
            <p data-id="element-194">
              La mayoría de las guías financieras fallan porque usan un lenguaje
              técnico y aburrido que nadie quiere leer. Usan términos como:
            </p>
            <div className="flex flex-wrap gap-3 py-2" data-id="element-195">
              <span className="line-through decoration-red-500 decoration-2 px-3 py-1 bg-white/5 rounded text-sm" data-id="element-196">
                amortización
              </span>
              <span className="line-through decoration-red-500 decoration-2 px-3 py-1 bg-white/5 rounded text-sm" data-id="element-197">
                activos circulantes
              </span>
              <span className="line-through decoration-red-500 decoration-2 px-3 py-1 bg-white/5 rounded text-sm" data-id="element-198">
                ROE
              </span>
            </div>
            <p data-id="element-199">que solo logran que cierres el libro a la tercera página.</p>
          </div>

          <div data-id="element-200">
            <h2 className="text-4xl md:text-5xl font-black neon-text-green mb-6" data-id="element-201">
              Teen Pro es diferente.
            </h2>
            <p className="text-xl text-gray-200 leading-relaxed" data-id="element-202">
              Hemos simplificado los principios de gestión de recursos de las
              mentes más brillantes y los hemos adaptado al mundo real de 2026.
              Es dinámico. Es visual. Es directo al grano.
            </p>
            <p className="text-xl text-gray-200 leading-relaxed mt-4" data-id="element-203">
              Es la{' '}
              <span className="bg-[#39FF14] text-black font-bold px-2 py-1 rounded mx-1 shadow-[0_0_10px_#39FF14]" data-id="element-204">
                hoja de ruta
              </span>{' '}
              para que aprendas a hacer que tus recursos crezcan de forma
              inteligente.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        rotate: 5
      }} whileInView={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="flex-1 relative" data-id="element-205">
          <div className="absolute inset-0 bg-gradient-to-tr from-[#39FF14]/20 to-transparent rounded-3xl blur-2xl -z-10" data-id="element-206"></div>
          <img src="https://cdn.magicpatterns.com/uploads/9emQQBX8nCDpYnD7aES4Ve/perfil_face.png" alt="Teen Pro" className="w-full max-w-md mx-auto drop-shadow-[0_0_40px_rgba(57,255,20,0.2)] rounded-3xl border border-white/10" data-id="element-207" />
        </motion.div>
      </div>
    </section>;
}